var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaybtn2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.997,
    height: 32.003,
    viewBox: "0 0 31.997 32.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,1.5A15.98,15.98,0,1,1,2.71,11.38a15.938,15.938,0,0,1,8.66-8.66A15.89,15.89,0,0,1,17.5,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.87,12.25a.424.424,0,0,1,.14-.06.772.772,0,0,1,.15-.02.59.59,0,0,1,.28.08l6.75,4.9a.637.637,0,0,1,.2.2.6.6,0,0,1,.08.29.566.566,0,0,1-.08.28.577.577,0,0,1-.2.21l-6.75,4.9a.555.555,0,0,1-.28.07.592.592,0,0,1-.29-.07.578.578,0,0,1-.2-.21.566.566,0,0,1-.08-.28v-9.8a.772.772,0,0,1,.02-.15.423.423,0,0,1,.06-.14.714.714,0,0,1,.2-.2Z",
    fill: "#868686"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybtn2);
export default __webpack_public_path__ + "static/media/playbtn2.e15ec8b8705620fb73a0ff7fd5bcd2fb.svg";
export { ForwardRef as ReactComponent };